export default __webpack_public_path__ + "static/media/JP1-1.2003c143.jpg";